import React from "react";
import { Route, Routes as Switch } from "react-router-dom";
import NotFound from "./error/NotFound";
import EventoDetalhePage from "./eventos-detalhes/EventoDetalhePage";
import EventosPage from "./eventos/EventosPage";
import FerramentasPage from "./ferramentas/FerramentasPage";
import DashboardPage from "./dashboard/DashboardPage";
import PendenciasPage from "./pendencias/PendenciasPage";
import TotalizadoresPage from "./totalizadores/TotalizadoresPage";

function Routes() {
  return (
    <Switch>
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<EventosPage />} />
      <Route path="/eventos/:id" element={<EventoDetalhePage />} />
      <Route path="/ferramentas" element={<FerramentasPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/pendencias" element={<PendenciasPage />} />
      <Route path="/totalizadores" element={<TotalizadoresPage />} />
    </Switch>
  );
}

export default Routes;
